import { ModalStore } from '../../../state/ModalStore'
import HomepageBookCallLeadModal from '../../Modals/HomepageBookCallLeadModal'
import GradientButton from '../GradientButton'
import WhiteButton from '../WhiteButton'

function BookACallFunnelButton({
    children = 'Book A Coaching Call',
    scheme = 'default',
}) {
    const addModal = ModalStore((state) => state.add)

    const handleClick = () => {
        addModal(<HomepageBookCallLeadModal />)
    }

    return scheme === 'white' ? (
        <WhiteButton onClick={handleClick}>{children}</WhiteButton>
    ) : (
        <GradientButton onClick={handleClick}>{children}</GradientButton>
    )
}

export default BookACallFunnelButton
